export default {
  navigation: {
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    login: 'Connexion',
    register: 'Inscription',
    signOut: 'Déconnexion',
    about: 'À propos',
    community: 'Communauté',
    explore: 'Explorer',
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    freelancer: 'Pigiste',
    client: 'Recruteur',
    help: 'Aide',
    show_details: 'Afficher les détails',
    findProject: 'Trouver un projet',
    findFreelancer: 'Trouver un pigiste',
    postProject: 'Publier un projet',
    articles: 'Articles',
    faq: 'FAQ',
    contact: 'Contact',
    searchPlaceholder: 'Recherche',
  },
  notFound: {
    title: 'Oups! Cette page a pris son envol',
    subtitle: "Nos pigeons n'ont pas encore livré cette page. Ils sont peut-être en pause café",
    backButton: 'Retour en arrière',
    homeButton: 'Retour au nid',
    footer1: 'Les pigeons sont en train de construire cette page...',
    footer2: 'Ils reviendront bientôt avec votre contenu!',
  },
  accountInactive: {
    contactSupport: "Si vous croyez qu'il s'agit d'une erreur, veuillez nous contacter à",
    inactive: {
      title: 'Votre compte est inactif',
      subtitle:
        "Votre compte est actuellement inactif et n'a pas accès à Pigeons. Contactez notre équipe pour le réactiver.",
    },
    suspended: {
      title: 'Votre compte est suspendu',
      subtitle:
        'Votre compte a été suspendu. Veuillez contacter notre équipe de support pour en savoir plus ou contester cette décision.',
    },
    banned: {
      title: 'Votre compte a été banni',
      subtitle:
        "Votre compte a été banni et n'a plus accès à Pigeons. Contactez notre équipe si vous croyez qu'il s'agit d'une erreur.",
    },
  },
  dashboard: {
    title: 'Tableau de bord',
    prospects: 'Contacts',
    alliances: 'Alliances',
    jobs: 'Projets',
    quotes: 'Soumissions',
    projectManager: 'Gestionnaire de projets',
  },
  footer: {
    freelancer: 'Pigiste',
    recruiter: 'Recruteur',
    community: 'Communauté',
    help: 'Aide',
    findProject: 'Trouver un projet',
    signup: "S'inscrire",
    articles: 'Articles',
    findFreelancer: 'Trouver un pigiste',
    publishProject: 'Publier un projet',
    blog: 'Blog',
    aboutPigeons: 'À propos de Pigeons',
    terms: "Conditions d'utilisation",
    privacy: 'Confidentialité',
    faq: 'FAQ',
    contactUs: 'Nous contacter',
    newsletterTitle: 'Abonnez-vous à notre Infolettre',
    emailPlaceholder: 'Votre courriel',
    emailAria: 'Votre courriel',
    accessibility: 'Accessibilité',
    copyright: '© {year} Pigeons',
    termsOfUse: "Conditions d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
  },
  newsletter: {
    title: 'Newsletter',
    placeholder: 'Entrez votre email',
  },
  language: {
    current: 'Français',
    fr: 'Français',
    en: 'Anglais',
  },
  error: {
    generic: 'Une erreur inattendue est survenue. Veuillez réessayer ou contacter le support.',
    required: 'Ce champ est requis',
    invalidEmail: 'Adresse email invalide',
    fieldRequired: 'Ce champ est requis',
    uploadImage: "Erreur lors du téléversement de l'image. Veuillez réessayer.",
    imageTooLarge: "La taille de l'image doit être inférieure à 5MB",
    boundary: {
      title: 'Une erreur est survenue',
      subtitle:
        "Nous sommes désolés, mais une erreur s'est produite lors du chargement de cette page.",
      reloadButton: 'Recharger la page',
      footer1: 'Les pigeons essaient de corriger cela...',
      footer2: 'Ils reviendront bientôt avec votre contenu !',
    },
  },
  role: {
    freelancer: 'Pigiste',
    recruiter: 'Recruteur',
    administrator: 'Administrateur',
  },
  companyType: {
    individual: 'Personnel',
    company: 'Corporatif',
    organization: 'Organisation',
  },
  obnl_review_status: {
    not_applicable: 'Non applicable',
    pending: 'En attente de validation',
    approved: 'Approuvé',
    rejected: 'Refusé',
  },
  status: {
    pending: 'En attente',
    accepted: 'Acceptée',
    rejected: 'Rejetée',
  },
  loading: 'Chargement...',
  noResults: 'Aucun résultat trouvé',
  remove: 'Retirer',
  loadMore: 'Charger plus',
  findItem: 'Trouver un-e',
  serviceCategories: {
    'administration-de-serveur': 'Administration de serveur',
    'administration-reseau': 'Administration réseau',
    'analyse-statistique': 'Analyse statistique',
    'animation-2d': 'Animation 2D',
    'animation-3d': 'Animation 3D',
    'applications-mobiles': 'Applications mobiles',
    artistes: 'Artistes',
    architecture: 'Architecture',
    'assistant-personnel': 'Assistant personnel',
    'blog-et-redaction-d-articles': "Blog et rédaction d'articles",
    camera: 'Caméra',
    'coiffure-maquillage': 'Coiffure/Maquillage',
    comptabilite: 'Comptabilité',
    'conception-graphique': 'Conception graphique',
    'consultant-en-gestion-d-entreprise': "Consultant en gestion d'entreprise",
    'contenu-de-site-web': 'Contenu de site web',
    costumes: 'Costumes',
    'creation-de-logo': 'Création de logo',
    'dba-administration-de-base-de-donnee': 'DBA - Administration de base de données',
    'design-d-interface-de-logiciel': "Design d'interface de logiciel",
    'design-d-interface-ux-ui': "Design d'interface UX-UI",
    'design-d-interieur': "Design d'intérieur",
    'design-imprime': 'Design imprimé',
    'design-web': 'Design web',
    'direction-artistique': 'Direction artistique',
    'direction-de-creation': 'Direction de création',
    'developpement-de-jeux': 'Développement de jeux',
    'developpement-de-logiciel-de-bureau': 'Développement de logiciel de bureau',
    'e-commerce': 'E-commerce',
    'ergonomie-de-logiciel': 'Ergonomie de logiciel',
    'ergonomie-web-qa': 'Ergonomie web QA',
    'erp-crm-mise-en-oeuvre': 'ERP / CRM mise en œuvre',
    'gestion-de-courriels': 'Gestion de courriels',
    'gestion-de-projet': 'Gestion de projet',
    'gestion-de-projet-logiciel': 'Gestion de projet logiciel',
    'gestion-de-projet-web': 'Gestion de projet web',
    'gestion-des-medias-sociaux': 'Gestion des médias sociaux',
    illustration: 'Illustration',
    'inbound-marketing-marketing-d-attraction': "Marketing d'attraction",
    'ingenierie-et-design-technique': 'Ingénierie et design technique',
    'intelligence-artificielle': 'Intelligence artificielle',
    juridique: 'Juridique',
    'logiciel-plug-ins': 'Logiciel plug-ins',
    'marketing-par-courriel': 'Marketing par courriel',
    'marketing-web': 'Marketing web',
    'modelisation-3d-et-cad': 'Modélisation 3D et CAD',
    photographie: 'Photographie',
    'plan-d-affaires': "Plan d'affaires",
    'post-production': 'Post-production',
    'pr-relations-publiques': 'PR - Relations publiques',
    'production-audio': 'Production audio',
    'production-imprime': 'Production imprimée',
    'production-tv': 'Production TV',
    'production-video': 'Production vidéo',
    'programmation-web': 'Programmation web',
    'presentation-graphique': 'Présentation graphique',
    publicite: 'Publicité',
    'recherche-web': 'Recherche web',
    recrutement: 'Recrutement',
    'ressources-humaines': 'Ressources humaines',
    realisation: 'Réalisation',
    redaction: 'Rédaction',
    'redaction-creative': 'Rédaction créative',
    'redaction-technique': 'Rédaction technique',
    'regie-tv': 'Régie TV',
    'regie-production': 'Régie production',
    'revision-de-textes': 'Révision de textes',
    'saisie-de-donnees': 'Saisie de données',
    'scripts-et-utilitaires': 'Scripts et utilitaires',
    'scenographie-decors': 'Scénographie/Décors',
    'sem-marketing-par-le-positionnement-payant-dans-les-moteurs-de-recherche':
      'SEM - Marketing par le positionnement payant dans les moteurs de recherche',
    'seo-optimisation-organique-pour-les-moteurs-de-recherche':
      'SEO - Optimisation organique pour les moteurs de recherche',
    'service-client': 'Service client',
    'service-conseil': 'Service conseil',
    'services-financiers-et-de-planification': 'Services financiers et de planification',
    'smm-marketing-par-les-medias-sociaux': 'SMM - Marketing par les médias sociaux',
    son: 'Son',
    'soutien-technique': 'Soutien technique',
    'soutien-telephonique': 'Soutien téléphonique',
    'strategie-et-planification': 'Stratégie et planification',
    technique: 'Technique',
    traduction: 'Traduction',
    'traitement-de-commandes-en-ligne': 'Traitement de commandes en ligne',
    'traitement-des-paiements': 'Traitement des paiements',
    'transcription-de-textes': 'Transcription de textes',
    transport: 'Transport',
    'telemarketing-et-televente': 'Télémarketing et télévente',
    'ventes-et-prospection': 'Ventes et prospection',
    voip: 'VOIP',
    'voix-hors-champ': 'Voix hors champ',
    'etudes-de-marche': 'Études de marché',
    'autres-communication-et-marketing': 'Communication et marketing',
    'autres-design-et-multimedia': 'Design et multimédia',
    'autres-developpement-de-logiciels': 'Développement de logiciels',
    'autres-developpement-web': 'Développement web',
    'autres-radio-tv-cinema-et-arts-de-la-scene': 'Radio-TV-Cinéma et arts de la scène',
    'autres-redaction-et-traduction': 'Rédaction et traduction',
    'autres-reseaux-et-systemes-d-information': "Réseaux et systèmes d'information",
    'autres-service-a-la-clientele': 'Service à la clientèle',
    'autres-services-aux-entreprises': 'Services aux entreprises',
    'autres-soutien-administratif': 'Soutien administratif',
  },
  home: {
    hero: {
      title: 'Trouvez les meilleurs freelances et équipes pour votre projet',
      subtitle: 'Connectez-vous, collaborez et réussissez grâce à notre plateforme intelligente.',
      getStarted: 'Commencer',
      browse: 'Parcourir les projets',
    },
    features: {
      title: 'Fonctionnalités',
      subtitle: 'Pourquoi choisir notre plateforme ?',
      smartMatching: {
        title: 'Appariement intelligent',
        description:
          'Notre algorithme avancé vous connecte avec les freelances et équipes les plus adaptés à vos besoins.',
      },
      teamFormation: {
        title: "Formation d'équipe",
        description: 'Formez et gérez facilement des équipes pour des projets de toute taille.',
      },
      securePayments: {
        title: 'Paiements sécurisés',
        description:
          "Profitez d'une tranquillité d'esprit grâce à notre système de paiement fiable et sécurisé.",
      },
    },
  },
  industries: {
    'accommodation-and-food-services': 'Hébergement et services de restauration',
    'advertising-and-public-relations': 'Publicité, relations publiques et services connexes',
    'aerospace-products-and-parts': 'Produits et pièces aérospatiaux',
    'agriculture-and-fishing': 'Agriculture et pêche',
    'architectural-and-engineering-services': "Services d'architecture et d'ingénierie",
    'arts-and-entertainment': 'Arts, spectacles et loisirs',
    'business-support-services': 'Services de soutien aux entreprises',
    'computer-and-electronic-products': 'Produits informatiques, électroniques et électriques',
    'computer-systems-design': 'Conception de systèmes informatiques',
    construction: 'Construction',
    'educational-services': "Services d'enseignement",
    'fabricated-metal-products': 'Fabrication de produits métalliques',
    finance: 'Finance',
    'food-and-beverage-manufacturing': "Fabrication d'aliments et de boissons",
    'forestry-and-logging': 'Foresterie et exploitation forestière',
    'furniture-manufacturing': 'Fabrication de meubles',
    'health-care': 'Soins de santé',
    'information-and-cultural-industries': "Industries de l'information et de la culture",
    insurance: 'Assurance et activités connexes',
    'legal-and-accounting-services': 'Services juridiques et comptables',
    'machinery-manufacturing': 'Fabrication de machines',
    'mining-and-oil-and-gas-extraction': 'Extraction minière, pétrolière et gazière',
    'miscellaneous-manufacturing': 'Fabrication diversifiée',
    'non-metallic-mineral-product-manufacturing':
      'Fabrication de produits minéraux non métalliques',
    'paper-manufacturing': 'Fabrication de papier',
    'petroleum-and-coal-products': 'Fabrication de produits pétroliers et charbonniers',
    'plastic-and-rubber-products': 'Fabrication de produits en plastique et en caoutchouc',
    'primary-metal-manufacturing': 'Fabrication de métaux de base',
    'printing-and-related-support': 'Imprimerie et activités de soutien connexes',
    'professional-scientific-and-technical-services':
      'Services professionnels, scientifiques et techniques',
    'public-administration': 'Administration publique',
    'real-estate': 'Services immobiliers et location',
    'retail-trade': 'Commerce de détail',
    'scientific-research-and-development': 'Recherche et développement scientifiques',
    'social-assistance': "Services d'assistance sociale",
    'transportation-and-warehousing': 'Transport et entreposage',
    utilities: 'Services publics',
    'waste-management': 'Gestion des déchets et assainissement',
    'wholesale-trade': 'Commerce de gros',
    'wood-product-manufacturing': 'Fabrication de produits en bois',
  },
  navBar: {
    home: 'Accueil',
    prospects: 'Contacts',
    alliances: 'Alliances',
    jobs: 'Projets',
    quotes: 'Soumissions',
    projects: 'Gestionnaire de projets',
    credits: 'Mes jetons',
    contacts: 'Contacts',
    settings: 'Paramètres',
    dockLeft: 'Ancrer la navigation à gauche',
    dockTop: 'Ancrer la navigation en haut',
  },
  breadcrumbs: {
    dashboard: 'Tableau de bord',
    settings: 'Mon profil',
    find: 'Trouver',
    freelancer: 'Un pigiste',
    notifications: 'Notifications',
    prospects: 'Prospects',
    jobs: 'Projets',
    alliances: 'Mes Alliances',
    quotes: 'Mes Soumissions',
    projects: 'Gestionnaire de projets',
    users: 'Utilisateurs',
    reports: 'Signalements',
    services: 'Services',
    industries: 'Domaines',
    cities: 'Villes',
    reviews: 'Evaluations',
    contacts: 'Contacts',
  },
  accountCard: {
    title: 'Mon compte',
    settings: 'Paramètres',
    wallet: 'Porte-monnaie',
    payment: 'Paiement',
    signOut: 'Déconnexion',
  },
  settings: {
    title: 'Mon profil',
  },
  mobileNavigation: {
    mainMenu: 'Menu principal',
    myCredits: 'Mes jetons',
  },
  form_fields: {
    firstName: 'Prénom',
    firstNamePlaceholder: 'Entrez votre prénom',
    lastName: 'Nom',
    lastNamePlaceholder: 'Entrez votre nom',
    city: 'Ville',
    cityPlaceholder: 'Entrez votre ville',
    postalCode: 'Code postal',
    postalCodePlaceholder: 'Entrez votre code postal',
    phone: 'Téléphone',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    languagesSpoken: 'Langue(s) parlée(s)',
    remoteWork: 'Travaillez-vous à distance',
    yes: 'Oui',
    no: 'Non',
    professionalDescription: 'Décrivez votre pratique professionnelle',
    professionalDescriptionPlaceholder:
      'Décrivez votre expérience professionnelle, vos compétences et ce qui vous rend unique',
    charactersRemaining: 'caractères restants',
    servicesOffered: 'Services offerts',
    servicesHint: 'Rechercher ou ajouter un service',
    selectService: 'Sélectionner un service',
    servicePlaceholder: 'Service ...',
    businessIndustries: "Secteurs d'activité",
    businessIndustriesHint: 'Ajouter minimum 1 secteur',
    newBusinessIndustryPlaceholder: "Nouveau secteur d'activité",
    businessIndustryNotFoundHint: "Vous n'avez pas trouvé votre secteur ? Ajoutez-le",
    newDescriptionPlaceholder: 'Description (optionnel)',
    companyName: 'Nom de la société',
    companyNamePlaceholder: 'Entrez le nom de votre société',
    jobTitle: "Votre rôle au sein de l'entreprise",
    jobTitlePlaceholder: "Entrez votre rôle au sein de l'entreprise",
    organizationWebsite: "Site web de l'organisation",
    organizationWebsitePlaceholder: "Entrez le site web de l'organisation",
    organizationNumber: "Numéro de l'organisation",
    organizationNumberPlaceholder: "Entrez le numéro de l'organisation",
  },
  form_actions: {
    cancel: 'Annuler',
    cancelling: 'Annulation...',
    confirm: 'Confirmer',
    confirming: 'Confirmation...',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    accept: 'Accepter',
    accepting: 'Acceptation...',
    decline: 'Refuser',
    declining: 'Déclination...',
    close: 'Fermer',
    next: 'Suivant',
    cancel_close: 'Annuler et fermer',
    send: 'Envoyer',
    sending: 'Envoi...',
    edit: 'Modifier',
    delete: 'Supprimer',
    editing: 'Modification...',
    back: 'Retour',
    previous: 'Précédent',
    skip: 'Passer',
    manage: 'Gérer',
    add: 'Ajouter',
    remove_industry: 'Supprimer le domaine',
    remove_serviceCategory: 'Supprimer le service',
    return: 'Retour',
  },
  cancelAndClose: 'Annuler et fermer',
  ratingLabels: {
    '0': 'Pas encore évalué',
    '1': 'Très mauvais',
    '2': 'Mauvais',
    '3': 'Moyen',
    '4': 'Bon',
    '5': 'Excellent',
  },
  achievements: {
    title: 'Réalisations',
    description: 'À propos',
  },
  search: {
    find: 'Trouver',
    findJob: 'Trouver un projet',
    findFreelancer: 'Trouver un-e pigiste',
    freelancer: 'Pigiste',
    project: 'Projet',
    search: 'Rechercher',
    searchPlaceholder: 'Que cherchez-vous?',
  },
  conjonctions: {
    for: 'pour',
  },
  alliance_statuses: {
    pending: "Demande d'alliance en attente",
    accepted: 'Alliance acceptée',
    rejected: 'Alliance rejetée',
    blocked: 'Alliance bloquée',
    retired: 'Alliance retirée',
  },
  budget_ranges: {
    less_than_500: 'Moins de 500$',
    '500_to_1000': '500$ à 1 000$',
    '1000_to_2000': '1 000$ à 2 000$',
    '2000_to_5000': '2 000$ à 5 000$',
    '5000_to_10000': '5 000$ à 10 000$',
    more_than_10000: 'Plus de 10 000$',
  },
  job_listing_types: {
    featured: 'En vedette',
    urgent: 'Urgent',
  },
  buttons: {
    viewProfile: 'Voir le profil',
  },
  quote_statuses: {
    draft: 'Brouillon',
    submitted: 'Soumise',
    accepted: 'Acceptée',
    rejected: 'Rejetée',
    retired: 'Retirée',
    change_requested: 'Modification demandée',
    job_cancelled: 'Projet annulé',
    alliance_retired: 'Invitation retirée',
    not_accepted: 'Non selectionnée',
  },
  job_statuses: {
    cancelled: 'Annulé',
    paused: 'En pause',
    in_progress: 'En cours',
    completed: 'Complété',
    open: 'Ouvert',
    closed: 'Fermé',
    expired: 'Expirée',
    reviewing_quotes: 'En révision des soumissions',
  },
  wallet: {
    title: 'Mon Porte-monnaie',
    credits: 'Mes jetons',
    manage: 'Gérer',
  },
  user_status: {
    active: 'Actif',
    inactive: 'Inactif',
    banned: 'banni',
  },
  content_type: {
    job: 'projet',
    profile: 'profile',
    review: 'évaluation',
    quote: 'devis',
    quote_request: 'demande de soumission',
    issue: 'problème technique',
  },
  report_status: {
    pending: 'En attente',
    resolved: 'Resolu',
    dismissed: 'ignoré',
  },
  update_user_status: 'Modifier le statut de <bold>{{user}}</bold>',
  update_job_status: 'Modifier le statut de <bold>{{job}}</bold>',
  select_status: 'Selectionner un status',
  update_status_button: 'Modifier le status',
  all_types: 'Tous les types',
  all_statuses: 'Tous les statuts',
  all_obnl_review_statuses: 'Tous les statuts OBNL',
  nothing_to_show: 'Rien à afficher',
  all_roles: 'Tous les rôles',
  languageTitle: 'Langue',
  service: 'Service',
  general: 'Général',
  add_new_service: 'Ajouter un nouveau service',
  add_new_industry: 'Ajouter un nouveau domaine',
  add_new_city: 'Ajouter une ville',
  serviceGroups: {
    administration_et_gestion: 'Administration et Gestion',
    design_et_multimedia: 'Design et Multimédia',
    developpement_web_et_logiciel: 'Développement Web et Logiciel',
    marketing_communication_et_ventes: 'Marketing, Communication et Ventes',
    production_audiovisuelle: 'Production Audiovisuelle',
    redaction_et_traduction: 'Rédaction et Traduction',
    services_juridiques: 'Services Juridiques',
    services_techniques_et_support: 'Services Techniques et Support',
    autres_services: 'Autres Services',
    autres: 'Autres',
  },
  badges: {
    language: 'Langue',
    service: 'Service',
    city: 'Ville',
    publishedAt: 'Date de publication',
    alphabetical: 'Classement alphabétique',
    allianceCount: "Classement par nombre d'Alliances",
    proximity: 'Proximité',
    rating: 'Évaluation',
  },
  errors: {
    generic: 'Une erreur est survenue',
  },
  alliances: {
    noneActive: 'Aucune alliance active',
  },
  MyWallet: 'Mon porte-monnaie',
  backToDashboard: 'Retour au tableau de bord',
  about: 'À propos',
  availability: 'Disponibilité',
  businessIndustries: "Secteurs d'activité",
  cancel_changes: 'Annuler les modifications',
  collapse: 'Réduire',
  expand: 'Déplier',
  first_name_fallback: 'Utilisateur',
  generic_error: 'Une erreur est survenue. Veuillez réessayer.',
  information: 'Informations',
  location: 'Localisation',
  noUsers: 'Aucun utilisateur récent',
  notification: 'Notification',
  requestQuote: 'Demander une soumission',
  viewJobs: "Voir les offres d'emploi",
  confirmEmail: {
    resendIn: 'Renvoi possible dans {{minutes}} min...',
    title: 'Vérifiez vos courriels',
  },
  new_industry_suggested_modal: {
    title: 'Suggérer un nouveau secteur',
  },
} as const;
